module.exports = __webpack_public_path__ + "img/scb.341040cf.svg";